import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getTeams, getJobTitles, getGrades, createAdmin } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";

const INIT_STATE = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    group: 1,
    team : "",
    gender:"",
    organization:"",
    password: "Password@123",
    status: "",
};

export default function NewEmployee() {
    const [teams, setTeams] = useState(null);
    const [titles, setTitles] = useState(null);
    const [grades, setGrades] = useState(null);
    const [state, setState] = useState(INIT_STATE);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        getTeams()
            .then((res) => {
                setTeams(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
    }, []);

    useEffect(() => {
        getJobTitles()
            .then((res) => {
                setTitles(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
    }, []);

    useEffect(() => {
        getGrades()
            .then((res) => {
                setGrades(res.data.data);
            })
            .catch((err) => {
                console.log(err.response.data.error)
            });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
            type: "inhouse"
        };
        console.log(data)
        if(data.first_name && data.address && data.email && data.phone && data.organization && data.type){
            setLoading(true);
            createAdmin(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                    console.log(res.data.message);
                } else {
                    alertError(res.data.message)
                    console.log(res.data.message)
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err.response)
                alertError(err.response?.data?.error);
                setLoading(false);
            });
        }
    };
        
    return (
        <>
            <h1 className="dash-title"><Link to="/hiring" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Hire New Employee</div>
                        </div>
                        <div className="card-body">
                        <form method="post" encType="multipart/form-data"  onSubmit={handleSubmit}>
                            <div className="row">
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">First Name: <span>*</span></label>
                                        <input name="first_name"  type="text" placeholder="First Name" className="form-control" required 
                                        onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Last Name: <span>*</span></label>
                                        <input name="last_name"  type="text" placeholder="Last Name" className="form-control" required  
                                        onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Email Address: <span>*</span></label>
                                        <input name="email" type="email" placeholder="Email" className="form-control" required  
                                        onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Phone Number: <span>*</span></label>
                                        <input type="tel" maxLength='11' placeholder="Phone Number" className="form-control" name="phone" required  
                                        onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Gender: <span>*</span></label>
                                        <select className="form-control form-select" name="gender" id="gender" required  
                                        onChange={handleChange} >
                                            <option value=''>Select Gender</option>
                                            <option value='male'>Male</option>
                                            <option value='female'>Female</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Address: <span>*</span></label>
                                        <input name="address"  type="text" placeholder="Address" className="form-control" required  
                                        onChange={handleChange} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Organization: <span>*</span></label>
                                        <select className="form-control form-select" name="organization" id="organization" required  
                                        onChange={handleChange} >
                                            <option value=''>Select Organization</option>
                                            <option value="6564981720e188a4442affd5">Kimberly Ryan Limited</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Team: <span>*</span></label>
                                        <select className="form-control form-select" name="team" id="team" required  
                                        onChange={handleChange} >
                                            <option value=''>Select Team</option>
                                            {teams && teams.map((team, i) => (
                                                <option key={i} value={team._id}>{team.team_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Job Role: <span>*</span></label>
                                        <select className="form-control form-select" name="job_title" id="job_title" required  
                                        onChange={handleChange} >
                                            <option value=''>Select Job Role</option>
                                            {titles && titles.map((title, i) => (
                                                <option key={i} value={title._id}>{title.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Staff Grade: <span>*</span></label>
                                        <select className="form-control form-select" name="grade" id="grade" required 
                                            onChange={handleChange}>
                                            <option value=''>Select Grade</option>
                                            {grades && grades.map((grade, i) => (
                                                <option key={i} value={grade._id}>{grade.grade}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Hire/Resumption Date: <span>*</span></label>
                                        <input name="hire_date" type="date" placeholder="Hire/Resumption Date" className="form-control" required />
                                    </div> */}
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Contract Type: <span>*</span></label>
                                        <select className="form-control form-select" name="contract_type" required  
                                        onChange={handleChange} >
                                            <option value=''>Select Contract Type</option>
                                            <option value='Salary'>Salary</option>
                                            <option value='Internship'>Internship</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Job Type: <span>*</span></label>
                                        <select className="form-control form-select" name="status" required  
                                        onChange={handleChange} >
                                            <option value=''>Select Job Type</option>
                                            <option value='Full-time'>Full-time</option>
                                            <option value='Part-time'>Part-time</option>
                                            <option value='Contract'>Contract</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button 
                                            type="submit" 
                                            disabled={loading} 
                                            className="btn btn-primary" 
                                            name="create_employee"
                                        >
                                            SUBMIT REQUEST
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
